module.exports = __webpack_public_path__ + "static/1344526137.e8b25e3e.jpg";